import CommandeUpdate from '../../views/CommandeUpdate';
import CommandeEleveDetails from '../../views/EspaceProf/CommandeEleveDetails';
import EspaceProf from '../../views/EspaceProf';
import Account from '../../views/MonProfil';
import pages from '../pages';
import { Route } from '../routes';

export const profRoutes: Route[] = [
  {
    path: pages.ELEVE_ACCOUNT_PAGE.path,
    component: Account
  },
  {
    path: pages.COMMANDE_ELEVE_DETAILS.path,
    component: CommandeEleveDetails
  },
  {
    path: pages.UPDATE_COMMANDE_PAGE.path,
    component: CommandeUpdate
  },
  {
    path: pages.ESPACE_PROF.path,
    component: EspaceProf
  }
];
